import { TpvExcelContainer } from '@/Store/ui/organisms'

export const TpvsExcelPage = (): JSX.Element => {

  return (<TpvExcelContainer />)
}
